module.exports = __webpack_public_path__ + "static/media/ic-user.33ae52ca.svg";